var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandWaving(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.571 6.78138C10.2855 6.27923 10.2102 5.68452 10.3615 5.12706C10.5129 4.56959 10.8786 4.09461 11.3788 3.80578C11.8791 3.51695 12.4733 3.43772 13.0317 3.58536C13.5902 3.73301 14.0676 4.09556 14.3597 4.59388L17.641 10.2814",
    stroke: "black",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58202 10.3545L6.02452 7.65619C5.73444 7.15363 5.65588 6.55641 5.80613 5.99593C5.95638 5.43544 6.32312 4.9576 6.82569 4.66752C7.32825 4.37744 7.92547 4.29888 8.48595 4.44913C9.04644 4.59938 9.52428 4.96613 9.81436 5.46869L13.2236 11.3749",
    stroke: "black",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3764 17.4999C16.7466 16.5693 16.4991 15.4322 16.685 14.324C16.8709 13.2159 17.476 12.2218 18.375 11.5477L17.6443 10.2811C17.3543 9.77815 17.2759 9.18052 17.4264 8.61972C17.577 8.05893 17.9441 7.58092 18.4471 7.29084C18.9501 7.00076 19.5478 6.92237 20.1086 7.07293C20.6694 7.22349 21.1474 7.59065 21.4375 8.09365L23.3307 11.3749C23.9053 12.3703 24.2781 13.4692 24.428 14.6088C24.5778 15.7483 24.5018 16.9062 24.2041 18.0163C23.9065 19.1265 23.3931 20.1671 22.6933 21.0789C21.9935 21.9906 21.121 22.7556 20.1255 23.3301C18.1151 24.4905 15.7261 24.8046 13.4841 24.2035C11.242 23.6024 9.3306 22.1353 8.17027 20.1249L3.79527 12.543C3.50977 12.0409 3.43448 11.4462 3.58582 10.8887C3.73717 10.3312 4.10288 9.85625 4.60313 9.56742C5.10338 9.27859 5.69757 9.19936 6.25603 9.347C6.81449 9.49465 7.29188 9.8572 7.58402 10.3555L9.68731 13.9999",
    stroke: "black",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 3.69482C21.7236 3.88591 22.4023 4.21837 22.9968 4.67303C23.5913 5.1277 24.0899 5.69556 24.4639 6.34389L24.5 6.40623",
    stroke: "black",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16156 25.375C6.94133 24.4109 5.91605 23.223 5.14062 21.875",
    stroke: "black",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandWaving);
export default __webpack_public_path__ + "static/media/HandWaving.20fdb9f0be6bf4f0e91bf0d138f996ca.svg";
export { ForwardRef as ReactComponent };